export default __webpack_public_path__ + "static/instructors-495b76a70186fa5a56012e3b8bd19b6d.png";